import { IconButton } from '@creditornot/cb-button';
import { ArrowLeft } from '@creditornot/cb-icons';
import React from 'react';

type Props = {
  onClick: () => void;
};

const BackButton = ({ onClick }: Props) => {
  return (
    <IconButton
      size="small"
      variant="black"
      onClick={() => {
        onClick();
      }}
    >
      <ArrowLeft />
    </IconButton>
  );
};

export default BackButton;
